import styled from 'styled-components';

export const StyledContainer = styled.section`
  width: 100%;
  min-width: 0;
  background: ${({ theme }) => theme.card};
  border: 1px solid ${({ theme }) => theme.border};
  border-radius: ${({ theme }) => theme.cardRadius};
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.04);
  padding: 24px 28px 28px;
  box-sizing: border-box;

  @media only screen and (max-width: 768px) {
    padding: 18px 16px 20px;
  }
`;
